import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'
// 引入vant
import Vant from 'vant'
import vantToast from './components/vant-toast.js';
import 'vant/lib/index.css'
import 'amfe-flexible'
import Loading from './components/Loading.vue'; // 导入你的Loading组件
import './assets/styles/buttons.css'

import { checkIOSDevice } from './utils/deviceCheck';
checkIOSDevice();

// import VConsole from 'vconsole';
// if (process.env.NODE_ENV === 'development') {
  // new VConsole();
// }

Vue.component('Loading', Loading); // 全局注册组件

Vue.use(Vant)
Vue.use(vantToast);

Vue.config.productionTip = false

// 注册全局点击状态指令
Vue.directive('clicked', {
  bind(el) {
      el.addEventListener('click', () => {
        // 添加临时点击效果
        el.classList.add('is-clicked')
        setTimeout(() => el.classList.remove('is-clicked'), 300)
        
        // 添加临时点击状态(1.5秒后自动移除)
        el.classList.add('temp-clicked')
        setTimeout(() => {
          el.classList.remove('temp-clicked')
        }, 1500)
      })
    }
})
new Vue({
	router,
	store,
  render: h => h(App),
}).$mount('#app')
